import type { SlideType } from '#base/core/types/SlideType';

export default [
	{
		title: [
			[
				{
					text: 'Wees zuinig op je lichaam,',
				},
			],
			[
				{
					text: 'en sport met een trainer.',
				},
			],
			[
				{
					text: 'Hier in Uden.',
					isBold: true,
				},
			],
		],
	},
	{
		title: [
			[
				{
					text: 'Hier gaat het om jou.',
				},
			],
			[
				{
					text: 'Met persoonlijke',
				},
			],
			[
				{
					text: 'aandacht.',
				},
				{
					text: 'Gewoon Hier.',
					isBold: true,
				},
			],
		],
	},
	{
		title: [
			[
				{
					text: 'Voel je sterker',
				},
			],
			[
				{
					text: 'en gemotiveerder.',
				},
			],
			[
				{
					text: 'Hier doe je het samen.',
					isBold: true,
				},
			],
		],
	},
	{
		title: [
			[
				{
					text: 'Hier sport je niet alleen.',
				},
			],
			[
				{
					text: 'We kennen je naam, en',
				},
			],
			[
				{
					text: 'je doel.',
				},
				{
					text: 'Hier wel.',
					isBold: true,
				},
			],
		],
	},
] as SlideType[];
